import React from "react";
import tableStyles from "../../styles/Table.module.css";
import TextLink from "../TextLink";

export default function TableDemo() {
    return (
        <>
            <div className={tableStyles.body}>
                Please review and accept the Credit Card Rate and Fee Information
            </div>
            <div className={tableStyles.header}>Interest Rates and Interest Charges</div>
            <div className={tableStyles.labelValueContainer}>
                <div className={tableStyles.labelValueRow}>
                    <div className={tableStyles.labelValue}>
                        <div className={tableStyles.label}>
                            Annual Percentage Rate (APR) for Purchases
                        </div>
                        <div className={tableStyles.value}>
                            <div>
                                <span className={tableStyles.valueBoldImportant}>0%</span>{" "}
                                Introductory APR for one year. After that, your APR will be
                                <span className={tableStyles.valueBoldImportant}> 29.9%</span>.
                            </div>
                            <div>This APR will vary with the market based on the Prime Rate.</div>
                        </div>
                    </div>
                </div>
                <div className={tableStyles.labelValueRow}>
                    <div className={tableStyles.labelValue}>
                        <div className={tableStyles.label}>
                            APR for Cash Advances and Balance Transfers
                        </div>
                        <div className={tableStyles.value}>
                            <div>
                                <span className={tableStyles.valueBoldImportant}>29%</span> This APR
                                will vary with the market based on the Prime Rate
                            </div>
                        </div>
                    </div>
                </div>
                <div className={tableStyles.labelValueRow}>
                    <div className={tableStyles.labelValue}>
                        <div className={tableStyles.label}>
                            How to Avoid Paying Interest on Purchases
                        </div>
                        <div className={tableStyles.value}>
                            <div>
                                Your due date is at least 21 days after the close of each billing
                                cycle. We will not charge you any inteest on purchases if you pay
                                the entire balance by your due date each month.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={tableStyles.header}>Fees</div>
            <div className={tableStyles.labelValueContainer}>
                <div className={tableStyles.labelValueRow}>
                    <div className={tableStyles.labelValue}>
                        <div className={tableStyles.label}>Annual Fee</div>
                        <div className={tableStyles.value}>
                            <div>
                                No Annual Fee for one year, then
                                <span className={tableStyles.valueBoldImportant}> $25</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={tableStyles.labelValueRow}>
                    <div className={tableStyles.labelValue}>
                        <div className={tableStyles.label}>Transaction Fees</div>
                        <div className={tableStyles.value} />
                    </div>
                    <div className={tableStyles.labelValue}>
                        <div className={tableStyles.labelDetail}>Cash Advance</div>
                        <div className={tableStyles.value}>
                            <div>
                                Either <span className={tableStyles.valueBoldImportant}>$3</span> or
                                <span className={tableStyles.valueBoldImportant}> 3%</span> of the
                                amount of each cash advance, whichever is greater.
                            </div>
                        </div>
                    </div>
                    <div className={tableStyles.labelValue}>
                        <div className={tableStyles.labelDetail}>Balance Transfer*</div>
                        <div className={tableStyles.value}>
                            <div>
                                Either <span className={tableStyles.valueBoldImportant}>$3</span> or
                                <span className={tableStyles.valueBoldImportant}> 3%</span> of the
                                amount of each transfer, whichever is greater.
                            </div>
                        </div>
                    </div>
                </div>
                <div className={tableStyles.labelValueRow}>
                    <div className={tableStyles.labelValue}>
                        <div className={tableStyles.label}>Penalty Fees</div>
                        <div className={tableStyles.value} />
                    </div>
                    <div className={tableStyles.labelValue}>
                        <div className={tableStyles.labelDetail}>Late Payment</div>
                        <div className={tableStyles.value}>
                            <div>
                                Up to <span className={tableStyles.valueBoldImportant}>$40</span>
                            </div>
                        </div>
                    </div>
                    <div className={tableStyles.labelValue}>
                        <div className={tableStyles.labelDetail}>Returned Payment</div>
                        <div className={tableStyles.value}>
                            <div>
                                Up to <span className={tableStyles.valueBoldImportant}>$40</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={tableStyles.header}>How We Will Calculate Your Balance:</div>
            <div className={tableStyles.body}>
                We use a method called “average daily balance (including new purchases).”
            </div>
            <div className={tableStyles.fineprint}>
                *Balances transferred from another credit card account up to your available credit
                limit are treated as a cash advance
            </div>
            <div className={tableStyles.fineprint}>
                If you have any questions, call Customer Service toll-free:{" "}
                <span className={tableStyles.valueBold}>1-800-733-1732</span>
            </div>
            <div className={tableStyles.notice}>
                Patriot Act Notice: Federal Law requires all financial institutions to obtain,
                verify, and record information that identifies each person who opens an account,
                including your name, address, date of birth and other information that will allow us
                to verify your identity.
            </div>
            <div className={tableStyles.fineprint}>
                <span className={tableStyles.valueBold}>NEW YORK RESIDENTS:</span> Consumer reports
                may be requested in connection with the processing of this application and any
                resulting account. Upon your request, we will inform you of the names and addresses
                of any consumer reporting agencies which have provided us with such reports. New
                York residents may contact the New York State Department of Financial Services to
                obtain a comparative list of credit card rates, fees and grace periods:{" "}
                <span className={tableStyles.valueBold}>1-877-226-5697</span> or
                <TextLink
                    className={tableStyles.link}
                    text=" www.dfs.ny.gov"
                    href="https://www.dfs.ny.gov"
                />
            </div>
            <div className={tableStyles.fineprint}>
                <span className={tableStyles.valueBold}>OHIO RESIDENTS:</span> The Ohio law against
                discrimination requires that all creditors make credit equality equally available to
                all creditworthy customers, and that credit reporting agencies maintain separate
                credit histories on each individual upon request. The Ohio Civil Rights Commission
                administers compliance with this law.
            </div>
            <div className={tableStyles.fineprint}>
                <span className={tableStyles.valueBold}>WISCONSIN RESIDENTS:</span> No agreement,
                court order, or individual statement applying to marital property will adversely
                affect a creditor’s interests unless prior to the time credit is granted, the
                creditor is furnished with a copy of the agreement, court order or statement, or has
                actual knowledge of the adverse provision.
            </div>
        </>
    );
}
